import { RICH_TEXT_NODES, RICH_TEXT_THEME } from '@plato/shared-util/lexical-config';
import { RichTextInput as UIRichTextInput, type RichTextValue } from '@plato/ui/components/rich-text-input';
import type { ReactElement } from 'react';
import { useLocale } from '../../../lib/hooks/use-locale.ts';
import type { VoiceInputPayload } from '../../analytics/types/analytics-events.ts';
import { ToolbarPlugin } from './toolbar-plugin.tsx';

export type { RichTextValue };

export type RichTextInputProps = {
    /** Analytics attribution for the voice mic — which field/composer this input is. */
    trackingContext: VoiceInputPayload;
    disableVoiceRecording?: boolean;
    autoFocus?: boolean;
    value: RichTextValue | undefined;
    onChange: (value: RichTextValue) => void;
    placeholder?: string;
    className?: string;
    contentClassName?: string;
    error?: boolean;
    disabled?: boolean;
    showClear?: boolean;
    onClear?: () => void;
};

export function RichTextInput({
    trackingContext,
    disableVoiceRecording,
    autoFocus = false,
    value,
    onChange,
    placeholder,
    className,
    contentClassName,
    error = false,
    disabled = false,
    showClear = false,
    onClear,
}: RichTextInputProps): ReactElement {
    const { t } = useLocale();

    return (
        <UIRichTextInput
            value={value}
            onChange={onChange}
            placeholder={placeholder}
            theme={RICH_TEXT_THEME}
            nodes={RICH_TEXT_NODES}
            namespace="RichTextViewer"
            error={error}
            autoFocus={autoFocus}
            disabled={disabled}
            showClear={showClear}
            onClear={onClear}
            clearLabel={t('rich_text_editor__clear')}
            className={className}
            contentClassName={contentClassName}
        >
            <ToolbarPlugin trackingContext={trackingContext} disableVoiceRecording={disableVoiceRecording} />
        </UIRichTextInput>
    );
}
